<script setup lang="ts">
import { computed } from 'vue'
import { SortDirection } from './enums/SortDirection.enum'
import { Icon } from '@iconify/vue2'
import { TableColumn } from './dtos/TableColumn.dto'

const props = defineProps<{
	tableHeader: TableColumn
}>()

const emit = defineEmits<{
	(event: 'directionChange', value?: SortDirection): void
}>()

function handleSort() {
	emit('directionChange', findNextSortDirection())
}

function findNextSortDirection(): SortDirection | undefined {
	switch (props.tableHeader.sortActive) {
		case SortDirection.DESC:
			return undefined
		case SortDirection.ASC:
			return SortDirection.DESC
		default:
			return SortDirection.ASC
	}
}

const sortDirectionIcon = computed(() => {
	switch (props.tableHeader.sortActive) {
		case SortDirection.DESC:
			return 'fa7-solid:sort-amount-desc'
		case SortDirection.ASC:
		default:
			return 'fa7-solid:sort-amount-asc'
	}
})
</script>

<template>
	<span class="flex items-center justify-between text-clip select-none">
		{{ tableHeader.name }}
		<div
			v-if="tableHeader.enableSort"
			@click="handleSort()"
		>
			<Icon
				:icon="sortDirectionIcon"
				class="text-4 cursor-pointer"
				:class="tableHeader.sortActive ? 'text-blue-base' : 'text-blue-tint-4'"
			/>
		</div>
	</span>
</template>
